/**
 * @generated SignedSource<<795128df45612776b6af33f61f9903b8>>
 * @relayHash 906443c090bbe63410dec52a5bf0c99e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f0cca951fca10bad995b44396772a08b87f578c4ffbc2643d82a60339e4124df

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

import boardHarmonisationM2FilterRefinement_provider from '@atlassian/jira-relay-provider/src/board-harm-filter-refinement.relayprovider';
import isJiraAiAgentAvatarFilterComponentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-filter-component.relayprovider';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f0cca951fca10bad995b44396772a08b87f578c4ffbc2643d82a60339e4124df",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcboardharmfilterrefinementrelayprovidertsx": boardHarmonisationM2FilterRefinement_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider": isJiraAiAgentAvatarFilterComponentEnabled_provider
    }
  }
};

export default node;
